import * as React from 'react'
import {Link} from 'react-router-dom'
import { connect } from 'react-redux'
import axios from 'axios'
import {toastr} from 'react-redux-toastr'
import {Button, TYPES} from './../components/shared/button'
import { fetchRecording } from  './../redux/actions/visits'
import VideoPlayer from './../components/video/videoPlayer'
import './../styles/video/video.css'
import Page from './../components/shared/page'
import arrow from './../images/left-arrow-circle.png'
import warning from './../images/warning.png'
import Modal from './../components/shared/modal'

var strftime = require('strftime')

class Video extends React.Component {

  constructor() {
    super()

    this.state = {
      showModal: false,
      daysToRestoreVideo: 7,
      tier: 'Standard'
    }
  }

  componentDidMount() {
    const id = Number(this.props.match.params.id)
    this.props.fetchRecording(id)
  }

  toggleModal = () => {
    this.setState({ showModal: !this.state.showModal })
  }

  licensePlateCheck = (num) => {
    if(num === null) {
      return 'No Plate Read'
    } else {
      return num
    }
  }

  outputPreviousRecordingLink = () => {
      return (
        <Link to={`/recordings/${this.props.visits.recording.previous_recording.id}`}>
          <Button
            text='Previous Vehicle'
            type='reviewOne'
            buttonType={TYPES.DEFAULT}
          />
        </Link>
      )
    }

  outputNextRecordingLink = () => {
      return (
        <Link to={`/recordings/${this.props.visits.recording.next_recording.id}`}>
          <Button
            text='Next Vehicle'
            type='reviewOne'
            buttonType={TYPES.DEFAULT}
          />
        </Link>
      )
    }

  outputArchivedRecordingWarning = () => {
    if(this.props.visits.recording.is_probably_archived) {
      return (
        <div className='video-archived'>
          <img src={warning} alt='warning symbol'/>
          <div>
            <h4>Video is archived</h4>
            {!this.props.auth.user.is_superuser &&
              <p><a href='mailto: tanner@baywatchtech.com'>Contact support</a> to get access</p>
            }
          </div>
          {this.props.auth.user.is_superuser &&
            <Button
              text='Restore'
              type='restore'
              onClick={() => {this.toggleModal()}}
              buttonType={TYPES.DEFAULT}
            />
          }
        </div>
      )
    }
  }

  outputAngleLink = (num) => {
    const { recordings } = this.props.visits.recording.visit
    if(typeof(recordings[num].angle) === 'number' && recordings[num].id !== null) {
      return (
        <Link to={`/recordings/${recordings[num].id}`}>
          <div className='default-angle'>
            {recordings[num].angle_name}
          </div>
        </Link>
      )
    } else if(typeof(recordings[num].angle) === 'number' && recordings[num].id === null) {
      return (
        <div>
          <div className='default-angle unavailable-angle'>
            {recordings[num].angle_name}
          </div>
        </div>
      )
    }
  }

  outputUnsupportedBrowserWarning = () => {
    const isFirefox = typeof InstallTrigger !== 'undefined'
    const isChrome = !!window.chrome && (
      !!window.chrome.webstore
      || navigator.vendor.toLowerCase().indexOf('google inc.') !== -1
    )
    if(!isChrome && !isFirefox) {
      return (
        <div className='video-archived'>
          <img src={warning} alt='warning symbol'/>
          <div>
            <h4>This page is optimized for Chrome and Firefox</h4>
            <p className='browser-check'>
              <a href='mailto: tanner@baywatchtech.com'>Contact support</a> with any issues
            </p>
          </div>
        </div>
      )
    }
  }

  onRestoreSubmit = (event) => {
    event.preventDefault()
    let headers = {"Content-Type": "application/json", "Authorization":`JWT ${this.props.auth.token}`}
    let visit_id = this.props.visits.recording.visit.id
    axios.post(`/api/visits/${visit_id}/restore.json/?days=${this.state.daysToRestoreVideo}&tier=${this.state.tier}`, {}, {headers})
      .then(res => {
        toastr.removeByType('error')
        toastr.success('Success', 'Restoration submitted')
      }).catch(function (error) {
        toastr.error('Error', error.response.data.error)
      })
  }

  render () {
    const { recording } = this.props.visits
    if(recording) {
      const id = Number(this.props.match.params.id)
      if(id !== recording.id) {
        this.props.fetchRecording(id)
      }
    }

    return (
      <Page history={this.props.history}>
        <div className='video-inner-container'>
          <div className='video-top'>
            {recording &&
              <Link to={`/visits/${recording.visit.id}`}>
                <div className='video-back-button'>
                  <img src={arrow} alt='Back'/>
                  <p>Back to angle selection</p>
                </div>
              </Link>
            }
            <div className='video-warning-box'>
              {recording && this.outputArchivedRecordingWarning()}
              {this.outputUnsupportedBrowserWarning()}
            </div>
            <div className='review-license-plate'>
              <p id='review-license-plate'>
                <b>License:</b>
                {recording && ' ' + this.licensePlateCheck(recording.visit.license_plate)}
              </p>
              <p>
                <b>Date:</b>
                {recording && ' ' + strftime('%D %I:%M %p', new Date(recording.visit.triggered_at))}
              </p>
              <p>
                <b>Bay:</b>
                {recording && ' ' + recording.visit.bay}
              </p>
              <p>
                <b>Angle:</b>
                {recording && ' ' + recording.angle_name}
              </p>
            </div>
          </div>
          <div className='video-bottom'>
            {recording &&
              <div className='available-angle-control-panel'>
                <div className='previous-recording'>
                  {recording.previous_recording && this.outputPreviousRecordingLink()}
                </div>
                <div className='angle-container'>
                  {this.outputAngleLink(4)}
                  {this.outputAngleLink(3)}
                  {this.outputAngleLink(5)}
                  {this.outputAngleLink(0)}
                  {this.outputAngleLink(6)}
                  {this.outputAngleLink(1)}
                  {this.outputAngleLink(7)}
                  {this.outputAngleLink(2)}
                </div>
                <div className='next-recording'>
                  {recording.next_recording && this.outputNextRecordingLink()}
                </div>
              </div>}
            <div className='video-player'>
              {recording &&
                <VideoPlayer videoURL={recording.video_url} recording_id={this.props.match.params.id} hiddenScreen={null} history={this.props.history} key={"videoPlayer" + this.props.match.params.id} hideSpinner={this.hideSpinner} />
              }
            </div>
          </div>
        </div>
        {this.state.showModal &&
          <Modal onCloseRequest={() => this.toggleModal()}>
              <div className='restore-archived-video-form-container'>
                <h3>Restore Video</h3>
                <form onSubmit={this.onRestoreSubmit} className='restore-archived-video-form'>
                  <label for='days'>Days:</label>
                  <select onChange={(event) => this.setState({daysToRestoreVideo: event.target.value})} id='days'>
                    <option>7</option>
                    <option>10</option>
                    <option>15</option>
                    <option>20</option>
                    <option>25</option>
                    <option>30</option>
                    <option>35</option>
                    <option>40</option>
                    <option>45</option>
                    <option>50</option>
                    <option>55</option>
                    <option>60</option>
                  </select>
                  <label for='tier'>Tier:</label>
                  <select onChange={(event) => this.setState({tier: event.target.value})} id='tier'>
                    <option value='Standard'>Standard</option>
                    <option value='Expedited'>Expedited</option>
                    <option value='Bulk'>Bulk</option>
                  </select>
                  <Button
                    text='Restore'
                    buttonType={TYPES.SUBMIT}
                  />
                </form>
              </div>
          </Modal>
        }
      </Page>
    )
  }
}

const mapStateToProps = (state) => {
  return state
}

const mapDispatchToProps = (dispatch)=> {
  return {
    fetchRecording: (id) => {
      return dispatch(fetchRecording(id));
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Video)



// WEBPACK FOOTER //
// ./src/pages/video.js